<template>
  <div>
    <Breadcrumbs main="shifts" title="End employee shift" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="edit-profile">
        <div class="row">
          <div class="col-xl-12">
            <div>
              <div class="container-fluid">
                <div class="loader-box" v-if="isLoading">
                  <div class="loader-20"></div>
                </div>
                <div class="row" v-if="getUser">
                  <div class="col-sm-12">
                    <div class="card">
                      <div class="card-header">
                        <h5>End shift</h5>
                        <b-row align-h="end">
                          <b-button
                            v-if="!isLoading && isAdmin"
                            align-h="end"
                            type="button"
                            @click="deleteUser"
                            class="btn-danger"
                            >Delete</b-button
                          ></b-row
                        >
                      </div>
                      <form class="form theme-form" @submit.prevent>
                        <div class="card-body">
                          <div class="row">
                            <div class="col">
                              <div class="form-group">
                                <label>Full name</label>
                                <b-form-input
                                  type="text"
                                  placeholder="Jan"
                                  v-model="fetchForm.fullName"
                                  disabled
                                ></b-form-input>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col">
                              <div class="form-group">
                                <label>Car registration</label>
                                <b-form-input
                                  type="text"
                                  placeholder="Kowalski"
                                  v-model="fetchForm.regPlate"
                                  disabled
                                ></b-form-input>
                              </div>
                            </div>
                          </div>
                          <div class="row" v-if="fetchForm.drivingSystem === '3Z' ">
                            <div class="col">
                              <div class="form-group">
                                <label>Shift</label>
                                <b-form-input
                                  type="text"
                                  v-model="fetchForm.shift"
                                  disabled
                                ></b-form-input>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col">
                              <div class="form-group">
                                <label>Starting date</label>
                                <b-form-datepicker
                                  type="date"
                                  v-model="fetchForm.date"
                                  disabled
                                ></b-form-datepicker>
                              </div>
                            </div>
                          </div>
                          <div class="row" v-if="fetchForm.drivingSystem !== '3Z' ">
                            <div class="col">
                              <div class="form-group">
                                <label>End date</label>
                                <b-form-datepicker
                                  type="date"
                                  v-model="today"
                                ></b-form-datepicker>
                              </div>
                            </div>
                          </div>
                          <div class="row" v-if="fetchForm.drivingSystem === '3Z' ">
                            <div class="col">
                              <div class="form-group">
                                <label>Shift earning</label>
                                <b-form-input
                                  type="number"
                                  v-model="fetchForm.earning"
                                  required
                                ></b-form-input>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col">
                              <div class="form-group">
                                <label
                                  >Current mileage - last mileage
                                  <strong>{{
                                    fetchForm.mileage
                                  }}</strong></label
                                >
                                <b-form-input
                                  type="number"
                                  v-model="fetchForm.endMileage"
                                  required
                                ></b-form-input>
                              </div>
                            </div>
                          </div>
                          <div class="row" v-if="fetchForm.drivingSystem === '3Z' ">
                            <div class="col">
                              <div class="form-group">
                                <label>Fuel cost</label>
                                <b-form-input
                                  type="number"
                                  v-model="fetchForm.fuel"
                                  required
                                ></b-form-input>
                              </div>
                            </div>
                          </div>
                          <div class="row" v-if="fetchForm.drivingSystem === '3Z' ">
                            <div class="col">
                              <div class="form-group">
                                <label>Taken money</label>
                                <b-form-input
                                  type="number"
                                  v-model="fetchForm.money"
                                  required
                                ></b-form-input>
                              </div>
                            </div>
                          </div>
                          <div class="row" v-if="fetchForm.drivingSystem === '3Z' ">
                            <div class="col">
                              <div class="form-group">
                                <label>Car wash cost</label>
                                <b-form-input
                                  type="number"
                                  v-model="fetchForm.carWashCost"
                                  required
                                ></b-form-input>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col">
                              <div class="form-group">
                                <label>Track recroding</label>
                                <b-form-select
                                  v-model="fetchForm.recording"
                                  :options="recordOptions"
                                ></b-form-select>
                              </div>
                            </div>
                          </div>

                          <div class="media">
                            <label class="col-form-label m-r-10">Damage</label>
                            <div class="media-body text-right">
                              <label class="switch">
                                <input
                                  type="checkbox"
                                  v-model="newDamage"
                                /><span class="switch-state"></span>
                              </label>
                            </div>
                          </div>
                          <div class="media">
                            <label class="col-form-label m-r-10"
                              >Next shift</label
                            >
                            <div class="media-body text-right">
                              <label class="switch">
                                <input
                                  type="checkbox"
                                  v-model="nextEmployee"
                                /><span class="switch-state"></span>
                              </label>
                            </div>
                          </div>
                          <div v-if="nextEmployee">
                            <label class="control-label">Next driver</label>
                            <div class="form-group m-t-15 custom-radio-ml">
                              <div class="radio radio-primary">
                                <b-form-radio
                                  v-for="user in getActiveUsers"
                                  :key="user.id"
                                  :name="user.firstName + ' ' + user.lastName"
                                  :value="{
                                    id: user.id,
                                    fullName:
                                      user.firstName + ' ' + user.lastName,
                                  }"
                                  v-model="fetchForm.selectedReciever"
                                  >{{
                                    `${user.lastName} ${user.firstName}`
                                  }}</b-form-radio
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="card-footer">
                          <b-button
                            type="button"
                            @click.prevent="updateShift"
                            variant="primary"
                            class="mr-1"
                            >End shift</b-button
                          >
                          <b-button type="reset" variant="light"
                            >Cancel</b-button
                          >
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title mb-0">Add projects And Upload</h4>
                <div class="card-options">
                  <a
                    class="card-options-collapse"
                    href="#"
                    data-toggle="card-collapse"
                    ><i class="fe fe-chevron-up"></i></a
                  ><a
                    class="card-options-remove"
                    href="#"
                    data-toggle="card-remove"
                    ><i class="fe fe-x"></i
                  ></a>
                </div>
              </div>
              <div class="table-responsive mb-0">
                <table class="table card-table table-vcenter text-nowrap">
                  <thead>
                    <tr>
                      <th>Project Name</th>
                      <th>Date</th>
                      <th>Status</th>
                      <th>Price</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <a class="text-inherit" href="#"
                          >Untrammelled prevents
                        </a>
                      </td>
                      <td>28 May 2018</td>
                      <td>
                        <span class="status-icon bg-success"></span> Completed
                      </td>
                      <td>$56,908</td>
                      <td class="text-right">
                        <a class="icon" href="javascript:void(0)"></a
                        ><a
                          class="btn btn-primary btn-sm"
                          href="javascript:void(0)"
                          ><i class="fa fa-pencil"></i> Edit</a
                        ><a class="icon" href="javascript:void(0)"></a
                        ><a
                          class="btn btn-transparent btn-sm"
                          href="javascript:void(0)"
                          ><i class="fa fa-link"></i> Update</a
                        ><a class="icon" href="javascript:void(0)"></a
                        ><a
                          class="btn btn-danger btn-sm"
                          href="javascript:void(0)"
                          ><i class="fa fa-trash"></i> Delete</a
                        >
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <a class="text-inherit" href="#"
                          >Untrammelled prevents</a
                        >
                      </td>
                      <td>12 June 2018</td>
                      <td>
                        <span class="status-icon bg-danger"></span> On going
                      </td>
                      <td>$45,087</td>
                      <td class="text-right">
                        <a class="icon" href="javascript:void(0)"></a
                        ><a
                          class="btn btn-primary btn-sm"
                          href="javascript:void(0)"
                          ><i class="fa fa-pencil"></i> Edit</a
                        ><a class="icon" href="javascript:void(0)"></a
                        ><a
                          class="btn btn-transparent btn-sm"
                          href="javascript:void(0)"
                          ><i class="fa fa-link"></i> Update</a
                        ><a class="icon" href="javascript:void(0)"></a
                        ><a
                          class="btn btn-danger btn-sm"
                          href="javascript:void(0)"
                          ><i class="fa fa-trash"></i> Delete</a
                        >
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <a class="text-inherit" href="#"
                          >Untrammelled prevents</a
                        >
                      </td>
                      <td>12 July 2018</td>
                      <td>
                        <span class="status-icon bg-warning"></span> Pending
                      </td>
                      <td>$60,123</td>
                      <td class="text-right">
                        <a class="icon" href="javascript:void(0)"></a
                        ><a
                          class="btn btn-primary btn-sm"
                          href="javascript:void(0)"
                          ><i class="fa fa-pencil"></i> Edit</a
                        ><a class="icon" href="javascript:void(0)"></a
                        ><a
                          class="btn btn-transparent btn-sm"
                          href="javascript:void(0)"
                          ><i class="fa fa-link"></i> Update</a
                        ><a class="icon" href="javascript:void(0)"></a
                        ><a
                          class="btn btn-danger btn-sm"
                          href="javascript:void(0)"
                          ><i class="fa fa-trash"></i> Delete</a
                        >
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <a class="text-inherit" href="#"
                          >Untrammelled prevents</a
                        >
                      </td>
                      <td>14 June 2018</td>
                      <td>
                        <span class="status-icon bg-warning"></span> Pending
                      </td>
                      <td>$70,435</td>
                      <td class="text-right">
                        <a class="icon" href="javascript:void(0)"></a
                        ><a
                          class="btn btn-primary btn-sm"
                          href="javascript:void(0)"
                          ><i class="fa fa-pencil"></i> Edit</a
                        ><a class="icon" href="javascript:void(0)"></a
                        ><a
                          class="btn btn-transparent btn-sm"
                          href="javascript:void(0)"
                          ><i class="fa fa-link"></i> Update</a
                        ><a class="icon" href="javascript:void(0)"></a
                        ><a
                          class="btn btn-danger btn-sm"
                          href="javascript:void(0)"
                          ><i class="fa fa-trash"></i> Delete</a
                        >
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <a class="text-inherit" href="#"
                          >Untrammelled prevents</a
                        >
                      </td>
                      <td>25 June 2018</td>
                      <td>
                        <span class="status-icon bg-success"></span> Completed
                      </td>
                      <td>$15,987</td>
                      <td class="text-right">
                        <a class="icon" href="javascript:void(0)"></a
                        ><a
                          class="btn btn-primary btn-sm"
                          href="javascript:void(0)"
                          ><i class="fa fa-pencil"></i> Edit</a
                        ><a class="icon" href="javascript:void(0)"></a
                        ><a
                          class="btn btn-transparent btn-sm"
                          href="javascript:void(0)"
                          ><i class="fa fa-link"></i> Update</a
                        ><a class="icon" href="javascript:void(0)"></a
                        ><a
                          class="btn btn-danger btn-sm"
                          href="javascript:void(0)"
                          ><i class="fa fa-trash"></i> Delete</a
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
export default {
  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    return {
      selected: null,
      formStatus: null,
      newDamage: false,
      nextEmployee: false,
      today: today,
      formData: {
        firstName: null,
        lastName: null,
        mail: null,
        phoneNum: null,
        workStart: null,
        drivingSys: null,
        active: null,
      },
      isLoading: false,
      recordOptions: [
        { value: "Working", text: "Yes" },
        { value: "Not working", text: "No" },
        { value: "Missing", text: "Missing video recorder" },
      ],
    };
  },
  created() {
    this.fetchSingleShift();
  },
  methods: {
    async updateShift() {
      if(this.nextEmployee){
        await this.addNew()
      }
      try {
        await this.$store.dispatch("shifts/updateShift", {
          data: {
            fullName: this.fetchForm.selectedPassing.fullName,
            selectedPassing: this.fetchForm.selectedPassing,
            selectedCar: this.fetchForm.selectedCar,
            regPlate: this.fetchForm.selectedCar.regPlate,
            date: this.fetchForm.date,
            shift: this.fetchForm.shift,
            endDate: this.today,
            earning: this.fetchForm.earning,
            money: this.fetchForm.money,
            endMileage: this.fetchForm.endMileage,
            drivenMileage: this.fetchForm.endMileage - this.fetchForm.mileage,
            fuel: this.fetchForm.fuel,
            damages: this.newDamage,
            dmgDesc: this.fetchForm.dmgDesc,
            carWashCost: this.fetchForm.carWashCost,
            recording: this.fetchForm.recording,
            shiftHandler: this.currentUser,
            nextDriver: this.nextEmployee,
            active: false,
          },
          param: this.$route.params.id,
        });
      } catch (error) {
        console.log(error);
        this.formStatus = true;
        this.basic_success_alert(
          "Something went wrong",
          "There is a problem with updating employee data - please try again later"
        );
      }

    },
    basic_success_alert: function(title, text) {
      this.$swal({
        title: title,
        text: text,
        type: "info",
      });
    },
    async addNew() {
      await this.$store.dispatch("shifts/addNewShift", {
        selectedPassing: this.fetchForm.selectedReciever.id,
        fullName: this.fetchForm.selectedReciever.fullName,
        selectedCar: this.fetchForm.selectedCar,
        regPlate: this.fetchForm.regPlate,
        shift: this.fetchForm.shift === "Day" ? "Night" : "Day",
        date: this.fetchForm.date,
        active: true,
        drivingSystem: this.fetchForm.drivingSystem,
        mileage: this.fetchForm.endMileage,
        nextDriver: this.nextEmployee,
        shiftHandler: this.currentUser,
      });
    },
    async fetchSingleShift() {
      this.isLoading = true;
      await this.$store.dispatch("shifts/fetchSingle", this.$route.params.id);
      await this.$store.dispatch("users/fetchUsers");
      this.isLoading = false;
    },
    async deleteUser() {
      await this.$swal({
        text: "Are you sure you want to do this?",
        showCancelButton: true,
        confirmButtonText: "Yes!",
        confirmButtonColor: "#4466f2",
        cancelButtonText: "Bring me back!",
        cancelButtonColor: "#efefef",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("users/deleteUser", this.$route.params.id);
          this.$router.push("/employees/manage");
        } else if (result.dismiss) {
          console.log("dissmised");
        }
      });
    },
  },
  computed: {
    getError() {
      const response = this.$store.getters["users/getError"];
      if (response.state) {
        return this.basic_success_alert(
          "We are sorry, employee not added",
          response.msg
        );
      }
    },
    currentUser() {
      let data = JSON.parse(localStorage.getItem("user"));
      return data.user.username;
    },
    getActiveUsers() {
      return !this.isLoading && this.$store.getters["users/getActiveUsers"];
    },
    isAdmin() {
      return !this.isLoading && this.$store.getters["auth/isAdmin"];
    },
    fetchForm() {
      return !this.isLoading && this.$store.getters["shifts/getSingle"];
    },
    getUser() {
      return !this.isLoading && this.$store.getters["users/getSingle"];
    },
  },
};
</script>
